import { render } from "./SemifraniaComponent.vue?vue&type=template&id=1129de00&scoped=true"
import script from "./SemifraniaComponent.vue?vue&type=script&lang=js"
export * from "./SemifraniaComponent.vue?vue&type=script&lang=js"

import "./SemifraniaComponent.vue?vue&type=style&index=0&id=1129de00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1129de00"]])

export default __exports__